export default {"src":"/_next/static/media/deck.f9cd50fc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};